import { _Filter_Types, FilterActions } from "./";
const _Filters_Handlers = {
	[_Filter_Types.Checkbox]: ({ _ApiTag, _Child_ApiTag, _SectionApiTag, dispatch }) => {
		dispatch({ type: FilterActions.Checkbox, value: { _ApiTag, _Child_ApiTag, _SectionApiTag } });
	},
	[_Filter_Types.Radio]: ({ _ApiTag, _Child_ApiTag, _SectionApiTag, dispatch }) => {
		dispatch({ type: FilterActions.Radio, value: { _ApiTag, _Child_ApiTag, _SectionApiTag } });
	},
	[_Filter_Types.Input]: ({ _ApiTag, _Child_ApiTag, value, _SectionApiTag, dispatch }) => {
		dispatch({ type: FilterActions.Input, value: { _ApiTag, _Child_ApiTag, value, _SectionApiTag } });
	},
	[_Filter_Types.TOP_LEVEL_FILTER]: ({ _ApiTag, _Child_ApiTag, _SectionApiTag, dispatch }) => {
		dispatch({ type: FilterActions.TOP_LEVEL_FILTER, value: { _ApiTag, _Child_ApiTag, _SectionApiTag } });
	},
	[_Filter_Types.Text]: ({ _ApiTag, value, _SectionApiTag, dispatch }) => {
		dispatch({ type: FilterActions.Text, value: { _ApiTag, value, _SectionApiTag } });
	}
};

export default _Filters_Handlers;
